import { render, staticRenderFns } from "./RadioCheckbox.vue?vue&type=template&id=84ab7ff0&"
import script from "./RadioCheckbox.vue?vue&type=script&lang=js&"
export * from "./RadioCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports